// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp } from 'vue'
// import VueLodash from 'vue-lodash'
// import lodash from 'lodash'
import router from './router/index'
// import VeeValidate from 'vee-validate'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { VTreeview } from 'vuetify/labs/components'
import { createI18n } from 'vue-i18n'
import createStore from './vuex/store'
import 'vuetify/dist/vuetify.min.css'
import App from './App'
import http from './library/http'
import * as filters from './library/global_filters'
import ja from './i18n/ja.json'
import en from './i18n/en.json'
import { configureCompat } from '@vue/compat'

import * as Sentry from '@sentry/vue'

const app = createApp(App)

// vuetify settings
const vuetify = createVuetify({
  components: {
    ...components,
    VTreeview
  },
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#0747A6',
          secondary: '#29A9CF',
          accent: '#42526E',
          error: '#F44336',
          warning: '#FF5722',
          info: '#0854C5',
          success: '#00BCD4'
        }
      }
    }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  }
})

// global settings
app.config.globalProperties.$http = http
app.config.globalProperties.$filters = filters
// resource of credential ID: https://console.cloud.google.com/apis/credentials?authuser=3&inv=1&invt=AbmQHw&project=och-power
app.config.globalProperties.$googleClientId = '227278786837-lrlir7tnnmqli66g26ouf7b6g75irrmr.apps.googleusercontent.com'

// global configuration
configureCompat({
  MODE: 3,
  COMPONENT_V_MODEL: false
})

app.use(vuetify)

// app.use(VueLodash, {
//   name: 'custom',
//   lodash: lodash
// })
// app.use(VeeValidate)

// i18n
const i18n = createI18n({
  fallbackLocale: 'en',
  messages: {
    en,
    ja
  }
})

// Sentry.init({
//   app,
//   dsn: 'https://7bca62a578a2d1682e98b3c016a893d3@o4507848540946432.ingest.de.sentry.io/4508141565771856',
//   environment: process.env.NODE_ENV,
//   integrations: [
//     Sentry.browserTracingIntegration({ router }),
//     Sentry.replayIntegration({
//       maskAllText: process.env.NODE_ENV === 'production'
//     })
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 0.1 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })

app.use(i18n)

app.use(router)
app.use(createStore)

app.mount('#app')


// old version
/* Global settings */
// Vue.prototype.$http = http
// Vue.use(Vuetify, {
//   theme: {
//     primary: '#0747a6',
//     secondary: '#29a9cf',
//     accent: '#42526e',
//     error: '#f44336',
//     warning: '#ff5722',
//     info: '#0854c5',
//     success: '#00bcd4'
//   }
// })
// Vue.use(VueLodash)
// Vue.use(VeeValidate)
// Vue.config.productionTip = false
// Vue.config.devtools = false

/* ライブラリから Vueフィルター読み込み */
// Object.keys(filters).forEach(key => {
//   Vue.filter(key, filters[key])
// })

/* ローカライズ */
// Vue.use(VueI18n)
//
// const i18n = new VueI18n({
//   fallbackLocale: 'en',
//   messages: {
//     en: require('./i18n/en.json'),
//     ja: require('./i18n/ja.json')
//   }
// })

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   i18n,
//   router,
//   store,
//   components: { App },
//   template: '<App/>'
// })
